/**
 * @generated SignedSource<<4532851e4a65afc30efb9652b726cee7>>
 * @relayHash be67b91b3b5b3d2fbcf3fcc898595c20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpObjectStoreArticleContentType = "FOLDER" | "PAGE" | "%future added value";
export type HelpObjectStoreArticleSearchExpandType = "ANCESTORS" | "VIEW_COUNT" | "%future added value";
export type HelpObjectStoreSupportSiteArticleSearchInput = {
  articleIds?: ReadonlyArray<string> | null | undefined;
  contentTypes?: ReadonlyArray<HelpObjectStoreArticleContentType> | null | undefined;
  expand?: ReadonlyArray<HelpObjectStoreArticleSearchExpandType> | null | undefined;
  orderBy?: string | null | undefined;
  parentId?: AGG$Long | null | undefined;
  query?: string | null | undefined;
  topLevelArticlesOnly?: boolean | null | undefined;
};
export type emptyStateQuery$variables = {
  cloudId: string;
  first?: number | null | undefined;
  helpCenterAri: string;
  input?: HelpObjectStoreSupportSiteArticleSearchInput | null | undefined;
};
export type emptyStateQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"emptyStateRenderer_data">;
};
export type emptyStateQuery = {
  response: emptyStateQuery$data;
  variables: emptyStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "emptyStateQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "emptyStateRenderer_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "emptyStateQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
        "kind": "LinkedField",
        "name": "helpObjectStore_searchArticlesForSupportSite",
        "plural": false,
        "selections": [
          {
            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "helpCenterAri",
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "EmptyStateRenderer__helpObjectStore_searchArticlesForSupportSite",
        "kind": "LinkedHandle",
        "name": "helpObjectStore_searchArticlesForSupportSite"
      }
    ]
  },
  "params": {
    "id": "77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365",
    "metadata": {},
    "name": "emptyStateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0f924812359a442723962628434695a3";

export default node;
